import { DjangoTimeStamped, TimeStamped } from './../django';
import { applyTimezone, parseDate } from './../helpers/date';
import { INSTALLMENT_STATUS } from './installment-status.model';

export class Installment implements TimeStamped {
  id: string;
  currency: string;
  number: number;
  amount: string;
  formattedReferencePeriod: Date;
  dueDate: Date;
  status: INSTALLMENT_STATUS;
  insuranceAmount: number;
  // DJANGO TIMESTAMPED
  created: Date;
  modified: Date;
  remainingAmount: Number;

  constructor(data: string | Installment | DjangoInstallment = {}) {
    if (data instanceof Installment) {
      bindInstallmentData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoInstallmentData(this, { id: data });
    } else {
      bindDjangoInstallmentData(this, data);
    }
  }
}

export function parseInstallment(data?: string | Installment | DjangoInstallment) {
  if (data) {
    return new Installment(data);
  } else {
    return undefined;
  }
}

function bindInstallmentData(installment: Installment, data: Installment) {
  installment.id = data.id;
  installment.currency = data.currency;
  installment.number = data.number;
  installment.amount = data.amount;
  installment.formattedReferencePeriod = data.formattedReferencePeriod;
  installment.dueDate = data.dueDate;
  installment.status = data.status;
  installment.insuranceAmount = data.insuranceAmount;
  // DJANGO TIMESTAMPED
  installment.created = data.created;
  installment.modified = data.modified;
  installment.remainingAmount = data.remainingAmount;

}

//////////////////////
/// DJANGO SUPPORT ///
//////////////////////
export interface DjangoInstallment extends DjangoTimeStamped {
  id?: string;
  currency?: string;
  number?: number;
  amount?: string;
  formatted_reference_period?: string;
  due_date?: string;
  status?: INSTALLMENT_STATUS;
  insurance_amount?: number;
  // DJANGO TIMESTAMPED
  created?: string;
  modified?: string;
  remaining_amount?: number;
}

function bindDjangoInstallmentData(installment: Installment, data: DjangoInstallment) {
  installment.id = data.id;
  installment.currency = data.currency;
  installment.formattedReferencePeriod = applyTimezone(parseDate(data.formatted_reference_period), 0);
  installment.number = data.number;
  installment.amount = data.amount;
  installment.dueDate = applyTimezone(parseDate(data.due_date), 0);
  installment.status = data.status;
  installment.insuranceAmount = data.insurance_amount;
  // DJANGO TIMESTAMPED
  installment.created = parseDate(data.created);
  installment.modified = parseDate(data.modified);
  installment.remainingAmount = data.remaining_amount;
}
